export default {
  defaultLayer: "Evapotranspiration",

  head: [
    {
      name: "NHP Home",
      path: "/",
      active: true,
    },
    {
      name: "Irrigation Home",
      path: "/webgis-irrigation",
      active: true,
    },
    {
      name: "Objective",
      path: "/webgis-irrigation/proj-obj",
    },
    {
      name:'Download Products',
      path:'/nhp-data-download'
    }
    // {
    //     name:"Technical Proposal",
    //     path:"/webgis-irrigation/tech-prop"

    // },
    // {
    //     name:"Project Team",
    //     path:"/webgis-irrigation/proj-team"

    // },
    // {
    //     name:"Financial Proposal",
    //     path:"/webgis-irrigation/fin-prop"
    // }

    // {

    //     name:"menu 3",
    //     path:"/"
    // },
  ],

  breadCrumbs: [
    {
      name: "menu 1",
      path: "/",
    },
    {
      name: "menu 2",
      path: "/",
    },
    {
      name: "menu 3",
      path: "/",
    },
  ],

  mapSideBar: [
    {
      id: 99,
      name: "Current Season",
      icon: "stroopwafel",
      hasdefault: true,
      default: "Optical",
      displayname: "Current Season",
      children: [
        {
          id: 1,
          name: "Command Area",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          // "default":true,
          displayname: "Irrigation System",
          default: true,
        },
      ],
    },
    {
      id: 2,
      name: "Historical Season",
      icon: "stroopwafel",
      hasdefault: false,
      default: "Optical",
      displayname: "Historical Season",
      children: [
        {
          id: 1,
          name: "Crop Map Historic",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          // "default":true,
          displayname: "Crop Map",
          default: true,
        },
        {
          id: 2,
          name: "Irrigation Requirement",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          displayname: "Irrigation Requirement",
          //  "default":true
        },
        {
          id: 3,
          name: "Irrigation System Performance",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          displayname: "Irrigation System Performance",
          //  "default":true
        },
      ],
    },
    {
      id: 1,
      name: "Satellite Imagery",
      icon: "stroopwafel",
      hasdefault: false,
      default: "Optical",
      displayname: "Satellite Imagery",
      children: [
        {
          id: 1,
          name: "Optical",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          // "default":true,
          displayname: "Optical",
          default: true,
        },
        {
          id: 2,
          name: "Microwave",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          displayname: "Microwave",
          //  "default":true
        },
      ],
    },
    // {
    //   id: 999,
    //   name: "Crop Map",
    //   icon: "stroopwafel",
    //   ismap: true,
    //   yearseason: true,
    //   displayname: "Satellite Data Derived Crop Map",

    //   //   "default":true
    // },



    // {
    //   id: 7,
    //   name: "Crop Condition Map",
    //   icon: "stroopwafel",
    //   ismap: true,
    //   yearseason: true,
    //   displayname: "Crop Condition Map",
    //   disabled: true,

    //   //   "default":true
    // },



    // {
    //   id: 3,
    //   name: "Crop Water Demand",
    //   displayname: "Crop Water Demand",
    //   children: [
    //     // {
    //     //     "id": 1,
    //     //     "name": 'Reference Evapotranspiration',
    //     //     "icon":"stroopwafel",
    //     //     "ismap":true,
    //     //     // "yearseason":true,
    //     // },
    //     {
    //       id: 2,
    //       name: "Crop Water Requirement",
    //       displayname: "Crop Water Requirement",
    //       icon: "stroopwafel",
    //       ismap: true,
    //       //  "yearseason":true,
    //     },
    //     {
    //       id: 3,
    //       name: "Irrigation Water Requirement",
    //       displayname: "Irrigation Water Requirement",
    //       icon: "stroopwafel",
    //       ismap: true,
    //       // "yearseason":true,
    //     },
    //   ],
    // },



    // {
    //   id: 10,
    //   name: "Delivery Schedule",
    //   displayname: "Delivery Schedule",
    //   icon: "stroopwafel",
    //   popup: true,
    //   disabled: true,
    //   //  "info":"",
    // },
    // {
    //   id: 11,
    //   name: "Actual Irrigation Deliveries",
    //   displayname: "Actual Irrigation Deliveries",
    //   icon: "stroopwafel",
    //   popup: true,
    //   disabled: true,
    //   //  "info":"",
    // },
    // {
    //   id: 14,
    //   name: "Command Area Performance Assessement",
    //   displayname: "Command Area Performance Assessement",
    //   icon: "stroopwafel",
    //   popup: true,
    //   disabled: true,
    //   //  "info":"",
    // },

    // {
    //     "id": 4,
    //     "name": 'Canal Releases',
    //     "icon":"stroopwafel",
    //     "dateRequired": true,
    //     "daily": true,
    //     "dateFormat":'YYYYMMDD',
    //     "dateDisplayFormat":'DD-MM-YYYY',
    //     "sliderDateFormat":"DD MMM YYYY",
    //     "hasDefault":true,
    //    // "default":'Monthly',
    //     "regex" :/[0-9]*/gm,
    //     // // "children": [
    //     // //     {
    //     // //         "id": 1,
    //     // //         "name": 'Optical',
    //     // //         "icon":"stroopwafel",
    //     // //         "ismap":true,
    //     // //         "default":true

    //     // //     },
    //     // //     {
    //     // //         "id": 2,
    //     // //         "name": 'Microwave',
    //     // //         "icon":"stroopwafel",
    //     // //         "ismap":true,
    //     // //         "default":true

    //     // //     },

    //     // ]
    // },
    // {
    //     "id": 5,
    //         "name": 'Base Layers',
    //         "icon":"stroopwafel",
    //        // "hasdefault":true,
    //         "children": [
    //             {
    //                 "id": 1,
    //                 "name": 'Canal Network',
    //                 "icon":"stroopwafel",
    //                 "ismap":true

    //             },

    //             {
    //                 "id": 2,
    //                 "name": 'Historical LULC',
    //                 "icon":"stroopwafel",
    //                 "ismap":true

    //             },
    //             {
    //                 "id": 3,
    //                 "name": 'Soil Map',
    //                 "icon":"stroopwafel",
    //                 "ismap":true

    //             },
    //             {
    //                 "id": 4,
    //                 "name": 'DEM',
    //                 "icon":"stroopwafel",
    //                 "ismap":true

    //             },
    //             {
    //                 "id": 5,
    //                 "name": 'Administrative Boundary',
    //                 "icon":"stroopwafel",
    //                 "ismap":true
    //             },
    //             {
    //                 "id": 5,
    //                 "name": 'River Network',
    //                 "icon":"stroopwafel",
    //                 "ismap":true
    //             }
    //         ]
    // },
    // {
  ],
};
